export enum Status {
    Draft = 'draft',
    Published = 'published',
    Archived = 'archived',
    Approved = 'approved',
    Rejected = 'rejected',
    Review = 'review',
}
